module.exports = __webpack_public_path__ + "media/1500_KMSAT45_2022_YRIntroduction.ce39e181.mp4";